import React from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import EditSVG from '@/images/svgs/Edit.svg?react'
import { EVENT_HUB_EDIT_ACCENT_CLASS, EVENT_HUB_EDIT_CONTROL_CLASS } from '../eventHub.utils'

/**
 * Blue outlined pencil that puts an organizer section into edit mode (Figma
 * 3790:20044 for the section titles, 3790:20104 for the sidebar). Hover fills
 * it blue with a white glyph (Figma 3790:24742 / 3790:24973).
 */
export default function EventHubEditButton({
    onClick,
    className = '',
    // Passed rather than overridden so two size utilities never collide in one class list.
    controlClass = EVENT_HUB_EDIT_CONTROL_CLASS,
}) {
    const { t } = useTranslation(TranslationNS.EVENT_PAGE)

    return (
        <button
            type="button"
            aria-label={t('Edit')}
            onClick={onClick}
            className={`${controlClass} ${EVENT_HUB_EDIT_ACCENT_CLASS} bg-white transition-colors hover:bg-[#1672ec] hover:text-white ${className}`}
        >
            <EditSVG className="size-3.25" />
        </button>
    )
}
